import { v4 as uuidv4 } from "uuid";
import { jwtDecode } from "jwt-decode";

function getDeviceId(): string {
  let deviceId = localStorage.getItem("deviceId") ?? uuidv4();
  localStorage.setItem("deviceId", deviceId);
  return deviceId;
}
export const device_id = getDeviceId();

export const decodeToken = (token: string) => {
  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};
export function convertUTCtoIST(date: Date): Date {
  let dateIST = new Date(date.getTime());
  const istOffset = 5.5 * 60 * 60 * 1000;
  dateIST = new Date(dateIST.getTime() + istOffset);
  return dateIST;
}